export default [
    {
        id: 1,
        name_ca: 'Habitatges',
        name_en: 'Housing',
        name_es: 'Viviendas',
    },
    {
        id: 2,
        name_ca: 'Oficines',
        name_en: 'Offices',
        name_es: 'Oficinas',
    },
    {
        id: 3,
        name_ca: 'Comercial',
        name_en: 'Retail',
        name_es: 'Comercial',
    },
    {
        id: 4,
        name_ca: 'Industrial',
        name_en: 'Industrial',
        name_es: 'Industrial',
    },
    {
        id: 5,
        name_ca: 'Aparcament',
        name_en: 'Parking',
        name_es: 'Aparcamiento',
    },
    {
        id: 6,
        name_ca: 'Trasters',
        name_en: 'Storage',
        name_es: 'Trasteros',
    },
    {
        id: 7,
        name_ca: 'Esportiu',
        name_en: 'Sports',
        name_es: 'Deportivo',
    },
    {
        id: 8,
        name_ca: 'Educacional',
        name_en: 'Educational',
        name_es: 'Educacional',
    },
    {
        id: 9,
        name_ca: 'Hoteler',
        name_en: 'Hoteler',
        name_es: 'Hoteler',
    },
    {
        id: 10,
        name_ca: 'Ús mixt',
        name_en: 'Mixed use',
        name_es: 'Úso mixto',
    }
]



// WEBPACK FOOTER //
// ./src/options/usage_types.js